import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../lib/auth.js';
import { Spinner } from '../components/ui/index.js';

// 인증된 사용자만 접근 가능한 라우트 가드
export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
